import React from 'react';
import styled from 'styled-components';
import {labels} from '../../../../../../util/utils';
import {independenceStatus, documentTypes} from '../../../../../../util/uiconstants';
import {useUserPreferences} from '../../../../../../util/customHooks';
import EllipsesControl from '../../../../../Common/EllipsesControl/EllipsesControl';
import EllipsesMoment from '../../../../../../components/Common/EllipsesControl/EllipseMoment';

export default function IndependenceDetails(props) {
	const {document} = props;

	const userPreferences = useUserPreferences();

	const setStatusLabel = (independenceStatusId) => {
		let independenceLabel = '';

		switch (independenceStatusId) {
			case independenceStatus.UNDEFINED:
				{
					independenceLabel = labels.undefined;
				}
				break;
			case independenceStatus.INCOMPLETE:
				{
					independenceLabel = labels.incomplete;
				}
				break;
			case independenceStatus.NOMATTERSIDENTIFIED:
				{
					independenceLabel = labels.noMattersIdentified;
				}
				break;
			case independenceStatus.MATTERIDENTIFIEDPENDINGACTION:
				{
					independenceLabel = labels.matterIdentifiedPendingAction;
				}
				break;
			case independenceStatus.MATTERRESOLVEDDENIEDACCESS:
				{
					independenceLabel = labels.matterResolvedDeniedAccess;
				}
				break;
			case independenceStatus.MATTERRESOLVEDGRANTEDACCESS:
				{
					independenceLabel = labels.matterResolvedGrantedAccess;
				}
				break;
			case independenceStatus.NOTAPPLICABLE:
				{
					independenceLabel = labels.notApplicable;
				}
				break;
			case independenceStatus.RESTORED:
				{
					independenceLabel = labels.restored;
				}
				break;
			case independenceStatus.OVERRIDDEN:
				{
					independenceLabel = labels.overridden;
				}
				break;
			case independenceStatus.PRIORNOMATTERSIDENTIFIED:
				{
					independenceLabel = labels.priorNoMattersIdentified;
				}
				break;
			case independenceStatus.PRIORMATTERIDENTIFIEDPENDINGACTION:
				{
					independenceLabel = labels.priorMatterIdentifiedPendingAction;
				}
				break;
			case independenceStatus.PRIORMATTERRESOLVEDGRANTEDACCESS:
				{
					independenceLabel = labels.priorMatterResolvedGrantedAccess;
				}
				break;
			case independenceStatus.PRIORMATTERRESOLVEDDENIEDACCESS:
				{
					independenceLabel = labels.priorMatterResolvedDeniedAccess;
				}
				break;
			default:
				independenceLabel = '';
		}

		return independenceLabel;
	};

	if (document?.documentTypeId !== documentTypes.INDEPENDENCEFORMINDIVIDUAL) {
		return null;
	}

	const {statusLastModifiedBy, modifyDate, independenceStatusId} = document?.independenceInformation || {};

	return (
		<StyledIndependenceDetails className="StyledIndependenceDetails">
			<section className="status-label">
				{labels.status}
				{': '}
			</section>
			<section className="status-label-Value">{setStatusLabel(independenceStatusId)}</section>
			<section className="status-by">
				{statusLastModifiedBy && labels.byLabel}
				{': '}
			</section>
			<EllipsesControl
				className="status-modified-by"
				content={statusLastModifiedBy}
				tooltip={statusLastModifiedBy}
				noOfLines={1}
			/>
			<section className="status-on">
				{statusLastModifiedBy && modifyDate && <section className="">{labels.onLabel}</section>}
			</section>
			{statusLastModifiedBy && modifyDate && (
				<EllipsesMoment
					id="independenceModifyDate"
					useFormat
					className="status-modified-date"
					userPreferences={userPreferences}
					date={modifyDate}
					useLocal={false}
				/>
			)}
		</StyledIndependenceDetails>
	);
}

const StyledIndependenceDetails = styled.section`
	display: flex;
	flex-direction: row;
	align-items: center;
	margin-top: var(--px-8);
	font-size: var(--px-16);
	font-weight: 300;
	line-height: var(--px-24);
	color: var(--neutrals-900);
	.status-label-Value,
	.ellipses,
	.status-modified-by,
	.status-modified-date {
		font-weight: 400;
		display: inline-flex;
		white-space: nowrap;
		width: auto;
		max-width: var(--px-400);
		margin: 0 var(--px-8);
	}
	.status-label {
		display: inline-flex;
		white-space: nowrap;
		width: auto;
		max-width: var(--px-150);
	}
	.status-label-Value {
		display: inline-flex;
		white-space: nowrap;
		width: auto;
		max-width: var(--px-400);
		margin: 0 var(--px-24) 0 var(--px-8);
	}
	.status-by {
		display: inline-flex;
		white-space: nowrap;
		width: auto;
		max-width: var(--px-100);
	}
	.status-modified-by {
		display: inline-flex;
		white-space: nowrap;
		width: auto;
		max-width: var(--px-400);
		margin: 0 var(--px-8);
	}
	.status-on {
		display: inline-flex;
		white-space: nowrap;
		width: auto;
		max-width: var(--px-100);
	}
	.status-modified-date {
		display: inline-flex;
		white-space: nowrap;
		width: auto;
		max-width: var(--px-400);
		margin: 0 var(--px-8);
	}
	/* .status-container {
		padding-right: var(--px-24);
		.status {
			font-size: var(--px-16);
			font-weight: 400;
			line-height: var(--px-24);
			color: var(--neutrals-900);
			.StatusMessageLabel {
				display: inline-flex;
			}
			.StyledEllipse {
				display: inline-flex;
			}
		}
		.status-label {
			padding-right: var(--px-5);
			font-size: var(--px-16);
			font-weight: 300;
			line-height: var(--px-24);
			color: var(--neutrals-900);
		}
	}
	.modified-by-container {
		.modified-by {
			font-size: var(--px-16);
			font-weight: 400;
			line-height: var(--px-24);
			color: var(--neutrals-900);
		}
		.modified-by-label {
			font-size: var(--px-16);
			font-weight: 300;
			line-height: var(--px-24);
			color: var(--neutrals-900);
		}
	}
	.modify-date-container {
		display: flex;
		flex-direction: row;
		.modify-date-label {
			margin-left: var(--px-8);
			margin-right: var(--px-8);
			font-size: var(--px-16);
			font-weight: 300;
			line-height: var(--px-24);
			color: var(--neutrals-900);
		}
		#independenceModifyDate {
			font-size: var(--px-16);
			font-weight: 400;
			line-height: var(--px-24);
			color: var(--neutrals-900);
		}
	} */
`;
